import { z } from 'zod';
import { PatientDataSchema } from './patientData';

export const notificationPreferences = ['SMS', 'PUSH', 'NONE'] as const;
export type NotificationPreference = (typeof notificationPreferences)[number];

export const PhoneSchema = z.string().regex(/^\+[1-9]\d{1,15}$/);

export const ParticipantSchema = z.object({
  id: z.string().uuid(),
  emaId: z.string(),
  email: z.string().email(),
  patientData: PatientDataSchema.optional(),
  phone: PhoneSchema.optional(),
  notificationPreference: z.enum(notificationPreferences).default('PUSH'),
  createdAt: z.string().datetime(),
  password: z.string().optional(),
});

export const ParticipantProfileSchema = ParticipantSchema.omit({
  password: true,
});

export const CreateParticipantSchema = z.object({
  emaId: z.string(),
  email: z.string().email(),
});

export const UpdateParticipantSchema = ParticipantSchema.omit({
  id: true,
  emaId: true,
  createdAt: true,
})
  .extend({
    phone: z.preprocess(
      (value) => (value === '' ? null : value),
      z
        .string()
        .regex(/^\+[1-9]\d{1,15}$/)
        .optional()
        .nullable(),
    ),
  })
  .partial();

export type ParticipantProfile = z.infer<typeof ParticipantProfileSchema>;
export type CreateParticipant = z.infer<typeof CreateParticipantSchema>;
export type UpdateParticipant = z.infer<typeof UpdateParticipantSchema>;
